import React, { useEffect, useContext } from "react";
import Edit_svg from "../../../svg/svg-body/Edit_svg";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import routeConstant from "../../../../route/compoent/routeConstant";
import { StoreContext } from "../../../store";
import { basename } from "../../../../config";
import { StoreContext as StoreContextTwo } from "../../../../store/Provider";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import instance from "../../../common/api/interceptor";
import { path } from "../../../constants/apiPath";
import Tooltip from "@mui/material/Tooltip";
// import {StroeContext as OldStoreContext} from '../../../../store'

function Card({ key, data, ...props }) {
  const location = useLocation();
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const contextTwo = useContext(StoreContextTwo);
  const orderPlan = data.PlanningCollection ?? [];
  const length = orderPlan.length;
  let planningCollection = {};
  let planFreezed = false;
  orderPlan.forEach((element) => {
    if (element.IsFreezed) {
      planningCollection = { ...element };
      planFreezed = true;
    }
  });

  if (Object.keys(planningCollection).length === 0) {
    planningCollection = { ...orderPlan[0] };
  }
  return (
    <>
      <div className="ribbon">{data.OrderStatusDescription}</div>
      <div className="_dashboardCardContent">
        <div className="container-fluid px-0">
          <div className="row">
            <div className="col-md-5 col-12 _dashboardCardContentLeft">
              <div className="_mail-Edit">
                {context.orderUserAccess?.EditOrder ? (
                  <div
                    title="Edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onEdit(data.OrderPK);
                    }}
                  >
                    <Edit_svg />
                  </div>
                ) : null}
              </div>
              <div className="_orderCardNumber flex-md-column flex-row justify-content-md-center justify-content-between">
                <Tooltip
                  title={
                    <div className="_hoverBox">
                      <p>Order Number : {data.OrderNumber}</p>
                    </div>
                  }
                  arrow
                >
                  <p>
                    {data.OrderNumber}
                    {data.SplitNumber !== "0" ? `/${data.SplitNumber}` : ""}
                  </p>
                </Tooltip>
                <p className="_cardDate label">
                  <span>{data.OrderActualWeight ? "Weight" : null}</span>
                  <span>{data.OrderActualVolume ? "Volume" : null}</span>
                </p>
                <p className="_cardDate value">
                  <span
                    title={
                      data.OrderActualWeight
                        ? `${data.OrderActualWeight} ${data.OrderUnitOfWeight}`
                        : null
                    }
                  >
                    {data.OrderActualWeight ? (
                      <>
                        {`${data.OrderActualWeight} ${" "}  ${
                          data.OrderUnitOfWeight
                        }`}
                      </>
                    ) : null}
                  </span>
                  <span
                    title={
                      data.OrderActualVolume
                        ? `${data.OrderActualVolume} ${data.OrderUnitOfVolume}`
                        : null
                    }
                  >
                    {data.OrderActualVolume ? (
                      <>
                        {`${data.OrderActualVolume}${" "}${
                          data.OrderUnitOfVolume
                        }`}
                      </>
                    ) : null}
                  </span>
                </p>
              </div>
            </div>
            <div className="col-md-7 col-12 _dashboardCardContentRight">
              {length && !planFreezed ? (
                <p
                  className="blink "
                  style={
                    data?.OrderStatus === "SHP" &&
                    data.PlanningCollection.length !== 0
                      ? { position: "absolute", right: "2rem" }
                      : {}
                  }
                >
                  Plan Updated
                </p>
              ) : null}
              {data?.OrderStatus === "SHP" &&
              data.PlanningCollection.length !== 0 ? (
                <span
                  className="_orderCardOpenNewTab"
                  title="Track"
                  onClick={(e) => {
                    console.log(data);
                    e.stopPropagation();
                    if (!planningCollection.OrderPlanningContainerCollection) {
                      NotificationManager.error(
                        "Tracking not available!!!\n\n Container not added yet!",
                        "",
                        3000
                      );
                    } else {
                      if (location.pathname.includes("dashboard")) {
                        navigate(routeConstant.ORDER_LIST_FULL_MILESTONE_DASH, {
                          state: {
                            orderData:
                              planningCollection.OrderPlanningContainerCollection,
                            carrier: planningCollection.PlanningCarrierSacCode,
                            masterBill: planningCollection.PlanningMasterBill,
                          },
                        });
                      } else {
                        navigate(routeConstant.ORDER_LIST_FULL_MILESTONE, {
                          state: {
                            orderData:
                              planningCollection.OrderPlanningContainerCollection,
                            carrier: planningCollection.PlanningCarrierSacCode,
                            masterBill: planningCollection.PlanningMasterBill,
                          },
                        });
                      }
                    }
                  }}
                >
                  <OpenInNewIcon />
                </span>
              ) : null}
              <p className="_orgDestHead">
                <span>Origin</span>
                <span>Destination</span>
              </p>
              <div className="_shptimelinebody">
                <span>{planningCollection.PlanningOriginPortCode}</span>
                <div className="_shptimelinecontainer">
                  <span>
                    <img
                      src={`/${basename}/Assets/Images/PlaceDot.png`}
                      alt="placeDot"
                    />
                  </span>
                  <span>
                    {data.OrderTransportMode === "AIR" ? (
                      <img
                        className="_shptimelinemode"
                        src={`/${basename}/Assets/Images/AirPlane.svg`}
                        alt="AirPlane"
                      />
                    ) : (
                      <img
                        className="_shptimelinemode"
                        src={`/${basename}/Assets/Images/Ship.png`}
                        alt="Ship"
                      />
                    )}
                  </span>
                  <span>
                    <img
                      src={`/${basename}/Assets/Images/PlaceDot.png`}
                      alt="placeDot"
                    />
                  </span>
                  <img
                    className="_dottedline"
                    src={`/${basename}/Assets/Images/Line.png`}
                    alt="line"
                  />
                </div>
                <span>{planningCollection.PlanningDestinationPortCode}</span>
              </div>
              <p className="_cardDate">
                <span>
                  {planningCollection.PlanningEstimatedDepart &&
                  moment(planningCollection.PlanningEstimatedDepart).format(
                    "MM-DD-YYYY"
                  ) !== "01-01-1900"
                    ? moment(planningCollection.PlanningEstimatedDepart).format(
                        "MM-DD-YYYY"
                      )
                    : "N/A"}
                </span>
                <span>
                  {planningCollection.PlanningEstimatedArrival &&
                  moment(planningCollection.PlanningEstimatedArrival).format(
                    "MM-DD-YYYY"
                  ) !== "01-01-1900"
                    ? moment(
                        planningCollection.PlanningEstimatedArrival
                      ).format("MM-DD-YYYY")
                    : "N/A"}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {contextTwo.omsUserData.UserRoles.includes("Supplier") ? (
        data.Is_SupplierMainorder && data.OrderType === "MAI" ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
              contextTwo.setNotificationOpen({
                type: "subOrder",
                open: true,
                orderPk: data.OrderPK,
                reload: false,
              });
            }}
            className="_accordioncard"
          >
            <div>View Sub Order</div> <ArrowForwardIosIcon />
          </div>
        ) : null
      ) : data.OrderType === "MAI" ? (
        <div
          onClick={(e) => {
            e.stopPropagation();
            contextTwo.setNotificationOpen({
              type: "subOrder",
              open: true,
              orderPk: data.OrderPK,
              reload: false,
            });
          }}
          className="_accordioncard"
        >
          <div>View Sub Order</div> <ArrowForwardIosIcon />
        </div>
      ) : null}
    </>
  );
}

export default Card;
